import { coreService } from 'network-utils';
import { useQuery } from 'react-query';

export const getLabInfo = 'fetch-lab-info';

export const useGetLabInfo = (token: string, labUuid: string, labsAccess: boolean) => {
    return useQuery([getLabInfo, labUuid], () => coreService.labsApi.getLabInfo(labUuid, token), {
        keepPreviousData: true,
        cacheTime: 0,
        enabled: !!token && !!labUuid && !!labsAccess
    });
};
